import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { alpha, styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { useErrorContext } from '@qpr/client-library';
import React, { useEffect, useState } from 'react';

const PREFIX = 'ListWidget';

const classes = {
  bgHover: `${PREFIX}-bgHover`,
  formLabelRoot: `${PREFIX}-formLabelRoot`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.bgHover}`]: {
    '&:hover': {
      background: theme.palette.primary.light
    }
  },

  [`& .${classes.formLabelRoot}`]: {
    color: alpha(theme.palette.grey[900], 0.62)
  }
}));

const ListWidget = ({ setValue, value, field, customProps }: any) => {
  const [options, setOptions] = useState<any[] | undefined>(undefined);
  const onChangeHandler = (event: React.ChangeEvent<{}>, newValue: any) => {
    setValue(newValue?.value || null);
  };
  const { setError } = useErrorContext();

  useEffect(() => {
    const initData = async () => {
      const gotOptions = await customProps.dataFetch(field);
      setOptions(gotOptions.data);
      if (gotOptions.error?.message) {
        setError(gotOptions.error);
      }
    };

    initData();
  }, []);

  const chosenValue = options?.find((obj: any) => {
    return obj.value === value;
  });

  return options !== undefined ? (
    <Autocomplete
      disabled={options.length === 0}
      className={classes.bgHover}
      classes={{
        root: classes.bgHover
      }}
      id={field}
      options={options || []}
      getOptionLabel={option => option.title}
      value={chosenValue || null}
      onChange={onChangeHandler}
      renderInput={params => (
        <TextField
          {...params}
          inputProps={{ ...params.inputProps, 'data-testid': `multiselect-widget-${field}-value` }}
          fullWidth
          InputLabelProps={{
            style: { fontWeight: 'normal' },
            classes: {
              root: classes.formLabelRoot
            }
          }}
          label="Select value"
          variant="outlined"
        />
      )}
    />
  ) : (
    <Root
      style={{ height: '56px', display: 'inline-flex', verticalAlign: 'top', alignItems: 'center' }}
    >
      <CircularProgress />
    </Root>
  );
};

export default ListWidget;
